//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    report: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    value: '',
  }),
  mounted() {
    if (this.report?.project?.client?.first_name) {
      this.value = 'Beste ' + this.report.project.client.first_name + '\n\nRapportage "' + this.report.title + '" staat voor u klaar.';
    }
  },
};
